'use strict';

angular.module('ringbaPortal.services').factory('queryPathMapService', queryPathMapService);

function queryPathMapService($http, $q, ngAuthSettings, callbackService) {
  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

  const columnSettings = {
    incomingQueryStringName: {
      class: 'tablesort-sortable',
      stSort: 'incomingQueryStringName',
      displayName: 'TAGS_STRING_NAME'
    },
    mapToTagType: {
      class: 'tablesort-sortable',
      stSort: 'mapToTagType',
      displayName: 'TAGS_CATEGORY'
    },
    mapToTagName: {
      class: 'tablesort-sortable',
      stSort: 'mapToTagName',
      displayName: 'TAGS_TYPE'
    }
  };

  const defaultColumns = [
    'incomingQueryStringName',
    'mapToTagType',
    'mapToTagName'
  ];

  const service = {
    columnSettings: columnSettings,
    defaultColumns: defaultColumns,
    getQueryPathMaps: getQueryPathMaps,
    getQueryPathMap: getQueryPathMap,
    getQueryPathMapsReference: getQueryPathMapsReference,
    createQueryPathMap: createQueryPathMap,
    deleteQueryPathMap: deleteQueryPathMap,
    updateQueryPathMap: updateQueryPathMap
  };
  return service;

  function getQueryPathMaps(accountId) {
    const url = serviceBaseUri + accountId + '/queryPathMaps';
    return $http.get(url);
  }

  function getQueryPathMap(accountId, queryPathMapId) {
    const url = _serviceBaseUrl(accountId, queryPathMapId);
    return $http.get(url);
  }

  function createQueryPathMap(accountId, queryPathMap) {
    const deferred = $q.defer();

    const url = serviceBaseUri + accountId + '/queryPathMaps';
    $http.post(url, queryPathMap).then(function (response) {

      callbackService.cleanMacros(accountId)
        .then(function () {
          deferred.resolve(response);
        }).catch(function () {
          deferred.resolve(response);
        });
    }).catch(deferred.reject);
    return deferred.promise;
  }

  function getQueryPathMapsReference(accountId, queryPathMapId) {
    const url = _serviceBaseUrl(accountId, queryPathMapId) + '/InboundReferences';
    return $http.get(url);
  }

  function deleteQueryPathMap(accountId, queryPathMapId, force) {
    const url = _serviceBaseUrl(accountId, queryPathMapId) + '?force=' + force;
    return $http.delete(url);
  }

  function updateQueryPathMap(accountId, queryPathMap) {
    const queryPathMapCopy = angular.copy(queryPathMap);
    if (queryPathMapCopy) {
      delete queryPathMapCopy.showEditForm;
    }
    const url = _serviceBaseUrl(accountId, queryPathMapCopy.id);
    return $http.patch(url, queryPathMapCopy);
  }

  function _serviceBaseUrl(accountId, queryPathMapId) {
    return serviceBaseUri + accountId + '/queryPathMaps/' + queryPathMapId;
  }
}
